// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".event-popup-companies-section__header[data-v-2b85f8a6]{margin-bottom:16px;font-weight:600;font-size:18px;line-height:27px;letter-spacing:.02em;color:#333}.event-popup-companies-section__body[data-v-2b85f8a6]{display:flex;flex-wrap:wrap;grid-gap:4px;gap:4px}.event-popup-companies-section__view-all-wrapper[data-v-2b85f8a6]{margin-top:12px;text-align:right}.event-popup-companies-section__view-all[data-v-2b85f8a6]{cursor:pointer;color:#0071bc}", ""]);
// Exports
module.exports = exports;
